import { inject, Injectable } from '@angular/core';
import { FolderDto, FolderPublicAccessLevel, FolderTenantAccessLevel } from '@nusign/picflow-backend-types';
import { firstValueFrom, Observable, switchMap, take } from 'rxjs';
import { FolderAccessLevel } from '../lib/access-level';
import { FolderAccessLevelSubService } from './folder-access-level-sub.service';
import { FolderService } from './folder.service';

@Injectable({
  providedIn: 'root',
})
export class FolderAccessLevelService {
  private folderAccessLevelSubService = inject(FolderAccessLevelSubService);
  private folderService = inject(FolderService);

  public isFolderGuest(folder: FolderDto): Observable<boolean> {
    return this.folderService.getSharedWithMeFolders().pipe(
      take(1),
      switchMap(sharedWithMeFolders => this.folderAccessLevelSubService.isFolderGuest(folder, sharedWithMeFolders))
    );
  }

  public async getAccessLevel(
    folder: FolderDto,
    options: { ignoreMemberList?: boolean; ignorePublicAccessLevel?: boolean } = {}
  ): Promise<FolderAccessLevel> {
    const [sharedFolders, folderChain] = await Promise.all([
      firstValueFrom(this.folderService.getSharedWithMeFolders()),
      firstValueFrom(this.folderService.getFolderChain(folder.id)),
    ]);
    return this.folderAccessLevelSubService.getAccessLevel(folder, folderChain, sharedFolders, options);
  }

  public async getAccessLevels(folderChain: FolderDto[]): Promise<[FolderTenantAccessLevel, FolderPublicAccessLevel]> {
    return this.folderAccessLevelSubService.getAccessLevels(folderChain);
  }
}
